import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { levelsApi } from "../../http/http";
import { isFresh } from "../cacheUtils";

const TTL_MS = 1000 * 60 * 60; // 1 hour

export const fetchLevels = createAsyncThunk(
  "levels/fetchLevels",
  async (token, thunkAPI) => {
    if (!token) throw new Error("Missing auth token");
    const res = await levelsApi(token);
    return res?.data?.levels || [];
  },
  {
    condition: (token, { getState }) => {
      const state = getState();
      if (!token) return false;
      const cacheToken = state.levels.token;
      if (cacheToken && cacheToken !== token) return true; // different user/token -> refetch
      return !isFresh(state.levels.lastFetched, TTL_MS);
    },
  }
);

const levelsSlice = createSlice({
  name: "levels",
  initialState: {
    token: null,
    levels: [],
    status: "idle",
    error: null,
    lastFetched: null,
  },
  reducers: {
    clearLevels(state) {
      state.token = null;
      state.levels = [];
      state.status = "idle";
      state.error = null;
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLevels.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchLevels.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.levels = action.payload;
        state.lastFetched = Date.now();
        state.token = action.meta.arg;
      })
      .addCase(fetchLevels.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Failed to load levels";
      });
  },
});

export const { clearLevels } = levelsSlice.actions;
export default levelsSlice.reducer;

